export default "/assets/images/face-with-monocle.7aca391ccdac5016.png";